<template>
  <li class="option" :value="props.value" :class="{ disabled: props.disabled }">
    <template v-if="$slots.content">
      <slot name="content"></slot>
    </template>
    <template v-else>
      {{ props.label }}
    </template>
  </li>
</template>
<script setup lang="ts">
import { defineEmits } from "vue";
import { optionProps, optiontEmit } from "./option";

const props = defineProps(optionProps);
const emits = defineEmits(optiontEmit);
</script>
<style lang="less" scoped>
.option {
  list-style-type: none;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 14px;

  font-weight: 400;
  color: #333333;
  line-height: 18px;
  padding-left: 13px;
  cursor: pointer;
}
.option-active {
  font-size: 14px;

  font-weight: 400;
  color: #A9823E;
  line-height: 18px;
}

.option:hover {
  font-size: 14px;
  font-weight: 400;
  color: #A9823E;
  line-height: 18px;
}
.disabled {
  color: #888888;
}
.disabled:hover {
  color: #888888;
  cursor: default;
}
</style>
